import { useFormsQuery, useFormSubmissionsQuery } from '../../lib/Queries';
import {
  CalendarIcon,
  ChevronRightIcon,
} from '@heroicons/react/24/outline/index.js';
import { formatDate, formatDateLong, formatTime } from '../../lib/DateTime.js';
import ClipboardText from '../icons/ClipboardText.jsx';
import ClipboardTextIcon from '../icons/ClipboardTextIcon.jsx';
import SubmissionDetailsPanel from './submissions/SubmissionDetailsPanel';
import { useState } from 'react';
import { Dropdown } from 'react-day-picker';
import Select from '../Select';
import Loading from '../Loading';
import CustomTags from '~/components/customfields/CustomTags.jsx';
import { ObjectTypes } from '~/lib/ObjectTypes.js';

const SubmissionRow = ({ submission, isFirst, onClick }) => {
  return (
    <div
      className={`cursor-pointer group sm:flex items-center justify-between ml-6 py-4 pr-4 ${!isFirst ? 'border-t' : ''}`}
      onClick={onClick}
    >
      <div>
        <div className="text-lg">{submission.client?.name}</div>
        <div className="text-gray-500 text-lg">{submission.client?.email}</div>
        <div className="text-gray-500 flex items-center mt-2">
          {submission.events_count > 0 && (
            <CalendarIcon className="w-4 h-4 mr-2" />
          )}
          {submission.events_count === 0 && (
            <ClipboardTextIcon className="w-4 h-4 mr-2" />
          )}

          {submission.form?.name}
        </div>
        <CustomTags
          type={ObjectTypes.FORM_SUBMISSION}
          id={submission.id}
          fields={submission.custom_fields}
        />
      </div>
      <div className="sm:flex items-center">
        <div className="text-gray-500 mr-4 sm:text-right">
          <div>{formatDateLong(submission.created_at)}</div>
          <div>{formatTime(submission.created_at)}</div>
        </div>
        <ChevronRightIcon className="hidden sm:block w-6 h-6 text-gray-300 group-hover:text-gray-500" />
      </div>
    </div>
  );
};

const SubmissionsList = ({}) => {
  const [sinceDaysAgo, setSinceDaysAgo] = useState('30');
  const [showForm, setShowForm] = useState(0);
  const { data, isLoading, refetch } = useFormSubmissionsQuery({
    sinceDaysAgo: sinceDaysAgo,
    form: showForm,
  });
  const { data: formsData, isLoading: isLoadingForms } = useFormsQuery(true);

  const formOptions = {
    0: 'All forms',
  };
  for (const form of formsData || []) {
    formOptions[form.id] = form.name;
  }

  const submissions = data?.results || [];
  const [selectedSubmission, setSelectedSubmission] = useState(null);

  return (
    <div>
      <div className="mb-4 flex items-center justify-end max-w-2xl gap-x-4">
        {!isLoadingForms && (
          <Select
            value={showForm}
            onChange={setShowForm}
            options={formOptions}
            inputClassName="max-w-32 sm:max-w-auto"
          />
        )}

        <Select
          value={sinceDaysAgo}
          onChange={setSinceDaysAgo}
          options={{
            1: 'Last 1 day',
            7: 'Last 7 days',
            14: 'Last 14 days',
            30: 'Last 30 days',
            90: 'Last 90 days',
            180: 'Last 180 days',
            365: 'Last Year',
            99999: 'All time',
          }}
        />
      </div>
      <div className="panel">
        {isLoading && <Loading className="px-6 py-4" />}
        {submissions.map((submission, idx) => (
          <SubmissionRow
            key={submission.id}
            submission={submission}
            isFirst={idx === 0}
            onClick={() => setSelectedSubmission(submission)}
          />
        ))}
        {!isLoading && submissions.length === 0 && (
          <div className="py-4 px-6 text-gray-500">
            There are no submissions.
          </div>
        )}
        <SubmissionDetailsPanel
          submission={
            selectedSubmission
              ? {
                  submission: selectedSubmission,
                  form: selectedSubmission.form,
                  answers: [],
                }
              : null
          }
          refetch={refetch}
          isOpen={!!selectedSubmission}
          onClose={() => setSelectedSubmission(null)}
        />
      </div>
    </div>
  );
};

export default SubmissionsList;
